import {
  marketLocationMasterData,
  marketLocationMasterDataDevices,
  marketLocationMasterDataMachines,
  root,
} from '@e2m-customer-portal/core';
import { useMarketLocationId, useMarketLocationSync } from '@e2m-customer-portal/hooks';
import { ErrorComponent, Loading, ModuleTabs, SweptTab } from '@e2m-customer-portal/ui';
import { ReactElement, Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import { Link, Navigate, Route, Routes, useLocation } from 'react-router';
import { MasterDataDevices } from './master-data-devices/MasterDataDevices';
import { MasterDataMachines } from './master-data-machines/MasterDataMachines';
import { MasterDataMarketLocation } from './master-data-market-location/MasterDataMarketLocation';

export function MasterDataPage(): ReactElement {
  const [t] = useTranslation();
  const { pathname } = useLocation();
  const marketLocationId = useMarketLocationId();
  if (marketLocationId == null) {
    throw new Error('Failed to retrieve market location id');
  }

  const { data, error } = useMarketLocationSync(marketLocationId);

  if (error) {
    return <ErrorComponent error={error} />;
  }

  if (!data) {
    return <Loading />;
  }
  return (
    <div className="flex flex-col">
      <ModuleTabs
        scrollButtons={false}
        value={pathname}
        className="w-fit origin-bottom-left scale-75 md:w-full md:transform-none"
      >
        <SweptTab
          component={Link}
          to={marketLocationMasterData.getLink(marketLocationId)}
          value={decodeURIComponent(marketLocationMasterData.getLink(marketLocationId))}
          label={t('MASTER_DATA_TAB_PLANT')}
        />

        <SweptTab
          component={Link}
          to={marketLocationMasterDataMachines.getLink(marketLocationId)}
          value={decodeURIComponent(marketLocationMasterDataMachines.getLink(marketLocationId))}
          label={t('MASTER_DATA_TAB_MACHINES')}
        />

        <SweptTab
          component={Link}
          to={marketLocationMasterDataDevices.getLink(marketLocationId)}
          value={decodeURIComponent(marketLocationMasterDataDevices.getLink(marketLocationId))}
          label={t('MASTER_DATA_TAB_DEVICES')}
        />
      </ModuleTabs>

      <ErrorBoundary FallbackComponent={ErrorComponent}>
        <Suspense fallback={<Loading />}>
          <Routes>
            <Route
              path={marketLocationMasterDataDevices.relativePath}
              element={<MasterDataDevices marketLocationId={marketLocationId} />}
            />

            <Route
              path={marketLocationMasterDataMachines.relativePath}
              element={<MasterDataMachines marketLocationId={marketLocationId} />}
            />

            <Route path="*" element={<MasterDataMarketLocation marketLocationId={marketLocationId} />} />

            <Route
              path="*"
              element={
                <Navigate
                  to={marketLocationId ? marketLocationMasterData.getLink(marketLocationId) : root.getLink()}
                  replace
                />
              }
            />
          </Routes>
        </Suspense>
      </ErrorBoundary>
    </div>
  );
}
